/**
 * Mutation APIs for Government Intake.
 * Backend: os.routes.ts — POST/PATCH/DELETE under /v0/os/government_intakes (admin).
 */

import axios from 'axios';
import { baseUrl, HttpMethods } from '@/api/base';
import type { DeleteGovernmentIntakeService, PatchGovernmentIntakeService, PostGovernmentIntakeService } from './types';

const governmentIntakeBasePath = `${baseUrl.OS}/government_intakes`;

/** Backend os.routes.ts: POST /v0/os/government_intakes — create intake (admin). */
export async function postGovernmentIntake({ data }: PostGovernmentIntakeService) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: governmentIntakeBasePath,
    data,
  });
  return res.data;
}

/** Backend os.routes.ts: PATCH /v0/os/government_intakes/:id — update intake. */
export async function patchGovernmentIntake({ intakeId, data }: PatchGovernmentIntakeService) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${governmentIntakeBasePath}/${intakeId}`,
    data,
  });
  return res.data;
}

/** Backend os.routes.ts: DELETE /v0/os/government_intakes/:id — archive intake. */
export async function deleteGovernmentIntake({ intakeId }: DeleteGovernmentIntakeService) {
  const res = await axios.request({
    method: HttpMethods.DELETE,
    url: `${governmentIntakeBasePath}/${intakeId}`,
  });
  return res.data;
}
